const houseBaseCoordinates = {
  1: { x0: "126", y0: "10" },
  2: { x0: "242", y0: "10" },
  3: { x0: "358", y0: "10" },
  4: { x0: "358", y0: "126" },
  5: { x0: "358", y0: "242" }, 
  6: { x0: "358", y0: "358" }, 
  7: { x0: "242", y0: "358" },
  8: { x0: "126", y0: "358" },
  9: { x0: "10", y0: "358" },
  10: { x0: "10", y0: "242" },
  11: { x0: "10", y0: "126" },
  12: { x0: "10", y0: "10" },
};

export default houseBaseCoordinates;
